import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL, PRICE_VALUE, PRODUCT_NAME, STICKY_CTA_LABEL } from '../data/halloweenKit';
import { trackPixelEvent } from '../utils/metaPixel';

/**
 * Single mobile buy bar. Appears once the hero has scrolled away and hides
 * while the hero, the main offer, or the final purchase card is on screen.
 */
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const targets = [document.getElementById('hero'), ...Array.from(document.querySelectorAll<HTMLElement>('[data-hide-sticky]'))].filter((el): el is HTMLElement => el !== null);
    const onScreen = new Set<Element>();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => e.isIntersecting ? onScreen.add(e.target) : onScreen.delete(e.target));
      setVisible(onScreen.size === 0);
    }, {
      threshold: 0
    });
    targets.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-229" data-mp="27b1m5grvjyi">
      {visible && <motion.div initial={{
      y: 64,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 64,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-0 left-0 right-0 z-40 w-full border-t border-pumpkin/20 bg-night-950/95 px-4 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 backdrop-blur lg:hidden" data-id="element-230" data-mp="28ds4ca6nkdw">
          <a href={CHECKOUT_URL ?? '#offer'} onClick={CHECKOUT_URL ? () => trackPixelEvent('InitiateCheckout', {
        content_name: PRODUCT_NAME,
        value: PRICE_VALUE,
        currency: 'USD'
      }) : undefined} className="mx-auto flex w-full max-w-md items-center justify-center whitespace-nowrap rounded-full bg-pumpkin px-4 py-3 text-[13px] font-bold uppercase leading-none tracking-[0.08em] text-night-950 transition-colors duration-150 ease-out active:bg-pumpkin-light" data-id="element-231" data-mp="luih66lnive6">
            {STICKY_CTA_LABEL}
          </a>
        </motion.div>}
    </AnimatePresence>;
}